/*
 * @description: 以登陆状态控制元素是否展示
 * @author: zb
 * @update: zb
 * @param form-ref-name   表单元素的引用
 * @LastEditors: zb
 * @Date: 2019-04-25 20:36:28
 * @LastEditTime: 2019-05-17 10:41:22
 */

import store from '@/store'

'use strict'
const loginShowDirective = function(el, binding, vnode) {
  const isLogin = store.getters && store.getters.userInfo && store.getters.userInfo.userId
  if (!isLogin) {
    el.setAttribute('style', 'display:none')
  }
}

export default loginShowDirective
